// extracted by mini-css-extract-plugin
export default {"country":"Country_country__EWLK8","flag":"Country_flag__Xgw02","countryName":"Country_countryName__RvMqK"};